export default {
  all (context) {
    var params = {
      page: context.page,
      order: context.order
    }
    context.loading = true
    context.$http.get('products', {params: params}).then(response => {
      context.loading = false
      context.products = response.body.data
      context.pagination = response.body.metadata.pagination
    })
  },
  get (context, id) {
    context.$http.get('products/' + id).then(response => {
      context.product = response.body.data[0]
    })
  },
  search (context, term, options) {
    return context.$http.post('products/search', {term: term}, options)
  }
}



// WEBPACK FOOTER //
// ./src/services/products.js